import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { MessageHelper } from "../helper/message-helper";
import { Logger } from "../logger/logger";
import { CheckResultData } from "../checkresultdialog/checkresultdata";

type ErrHandler<T> = (err?: any) => T;
type AsyncErrHandler<T> = (err?: any) => Promise<T>;

interface IErrorHandlerOptions<T> {
	default?: T;
	message?: string;
	severity?: "info" | "warning" | "error";
}

export class ErrorHandler {
	public static log<T>(options?: IErrorHandlerOptions<T>): ErrHandler<T> {
		options = this.getDefaultOption(options);
		return (err?: any) => {
			this.logError(err, options);

			return options.default;
		};
	}

	public static toast<T>(options?: IErrorHandlerOptions<T>): ErrHandler<T> {
		options = this.getDefaultOption(options);
		return (err?: any) => {
			this.logError(err, options);

			MessageHelper.uiError(this.getDisplayMessage(err, options));
			return options.default;
		};
	}

	public static dialogAsync<T>(options?: IErrorHandlerOptions<T>): AsyncErrHandler<T> {
		options = this.getDefaultOption(options);
		let checkResultHandler = this.checkResult(options);
		return async (err?: any) => {
			this.logError(err, options);

			let result = await checkResultHandler(err);
			await DialogResultVm.showDialogAndGetResultAsync(result);
			return options.default;
		};
	}

	public static checkResult<T = any>(options?: IErrorHandlerOptions<any>): ErrHandler<CheckResultData<T>> {
		options = this.getDefaultOption(options);
		return (err?: any) => {
			this.logError(err, options);

			let message = this.getDisplayMessage(err, options);

			let checkData: CheckResultData;
			if (CheckResultData.isCheckResultData(err)) {
				checkData = err;
			} else {
				checkData = new CheckResultData();
				checkData.error = err;
			}

			switch (options.severity) {
				case "info":
					checkData.addInfo(message);
					break;

				case "warning":
					checkData.addWarning(message);
					break;

				case "error":
				default:
					checkData.addError(message);
					break;
			}

			checkData.addError(this.getDisplayMessage(err, options));
			return checkData;
		};
	}

	private static getDisplayMessage(err: any, options: IErrorHandlerOptions<any>): string {
		if (options.message) {
			return options.message;
		}

		// TODO(jpg): handle specific errors like jquery 4xx/5xx here

		return "Es ist ein interner Fehler aufgetreten.";
	}

	private static getDefaultOption<T>(options: IErrorHandlerOptions<T>) {
		options = $.extend(true, {}, options || {});

		if (options.default == null) {
			options.default = null;
		}

		if (options.severity == null) {
			options.severity = "error";
		}

		return options;
	}

	private static logError(err: any, options: IErrorHandlerOptions<any>) {
		let args = [this.getDisplayMessage(err, options), err];

		switch (options.severity) {
			case "info":
				Logger.logWithTrace(...args);
				break;

			case "warning":
				Logger.warnWithTrace(...args);
				break;

			case "error":
			default:
				Logger.errorWithTrace(...args);
				break;
		}
	}

	private constructor() { }
}